import React from 'react'
import { Route, Routes } from 'react-router-dom';
import CustomerList from './CustomerList';
import AddCustomer from './AddCustomer';
import TaxDetails from './TaxDetails';

export default function CustomerRoute() {
     return (
          <Routes>
              <Route path="/" element={<CustomerList />} />
              <Route path="/add" element={<AddCustomer />} />
              <Route path="/edit/:id" element={<AddCustomer />} />
              <Route path="/taxDetails/:id" element={<TaxDetails />} />             
          </Routes>
      )
}
